import { render, staticRenderFns } from "./WorkIconRotate.vue?vue&type=template&id=2127abbd"
import script from "./WorkIconRotate.vue?vue&type=script&lang=js"
export * from "./WorkIconRotate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports